var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:_vm.$style.container},[_c('figure',{class:_vm.$style.image},[_c('img',{attrs:{"alt":_vm.title,"src":_vm.src}})]),_c('HeadingMedium',[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }